import { GameManager } from "./GameManager";
import { GameVars } from "./GameVars";

import "howler";

export class AudioManager {

    public static sound: Howl;
    public static musicID: number;
    public static musicKey: string;
    public static matchingID: number;

    public static init(): void {

        AudioManager.sound.mute(GameVars.gameData.muted);
    }

    public static switchAudioState(): void {

        GameVars.gameData.muted = !GameVars.gameData.muted;

        GameManager.writeGameData();

        AudioManager.sound.mute(GameVars.gameData.muted);
    }

    public static playSound(key: string, loop?: boolean, volume?: number, rate?: number): void {

        loop = loop || false;
        volume = volume || 1;
        rate = rate || 1;

        if (loop && key === AudioManager.musicKey) {
            return;
        }

        let id = AudioManager.sound.play(key);
        AudioManager.sound.loop(loop, id);
        AudioManager.sound.rate(rate, id);
        AudioManager.sound.volume(volume, id);

        if (loop) {
            AudioManager.musicID = id;
            AudioManager.musicKey = key;
        }
    }

    public static playMatching(key: string) {

        let id = AudioManager.sound.play(key);
        AudioManager.sound.loop(true, id);
        AudioManager.matchingID = id;
    }

    public static stopMatching(): void {

        if (AudioManager.matchingID) {
            AudioManager.sound.fade(1, 0, 500, AudioManager.matchingID);
            AudioManager.matchingID = null;
        }
    }

    public static stopMusic(): void {

        if (AudioManager.musicID) {
            AudioManager.sound.stop(AudioManager.musicID);
            AudioManager.musicID = null;
            AudioManager.musicKey = null;
        }
        
    }
}
